import { defineMessage } from 'react-intl';

const requiredMessage = defineMessage({
    defaultMessage: '{label} is required',
    id: 'bAUoRd',
    description: 'Error message indicating field with label is required'
});

export { requiredMessage };
//# sourceMappingURL=messages.esm.js.map
